export default __webpack_public_path__ + "static/media/01n.561b7907.png";